import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Detection } from '../../../../models/detection';
import {
  selectDetection
} from '../../../../features/detection/detection.actions';
import {
  DetectionMode,
  DetectionStatus,
} from '../../../../enums/detection';
import { Observable } from 'rxjs';
import {
  selectDetectionById
} from '../../../../features/detection/detection.selectors';


@Component({
    selector: 'detection-card',
    templateUrl: './detection-card.component.html',
    styleUrls: ['../card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DetectionCardComponent {

  private _detectionId!: string;

  @Input({ required: true })
  set detectionId(value: string) {
    this._detectionId = value;
    this.detection$ = this.store.select(selectDetectionById(value));
  }
  detection$!: Observable<Detection | undefined>;

  detectionStatusEnum = DetectionStatus;
  detectionCreateModeEnum = DetectionMode;

  constructor(private store: Store) {
  }

  onClickEdit(detection: Detection): void {
    this.store.dispatch(selectDetection({id: detection.id}));
  }
}
